<template>
  <div>
    <div>
      <!-- Para mecánico el code está en i18n (pilings/structures/...). Para
           electrical/trenches el code es 'electrical_n'/'trench_n' (sin
           traducción) y mostramos `layer.name` que es lo que el admin editó
           al guardar. $te() verifica si la clave i18n existe sin matchear el
           fallback literal. -->
      <p class="mb-1">{{ $t('layer') }}: <strong>{{ $te(layer.code) ? $t(layer.code) : layer.name }}</strong></p>
      <p class="mb-1">{{ $t('weight') }}: <strong>{{ layer.weight }}</strong></p>
      <p class="text-lg font-medium">{{ _GetAdvance(layer.metadata, 'normalize') }}% {{ $t('of') }} 100 {{ $t('completed') }}</p>
      <div class="flex items-center gap-2">
        <segmented-progress-bar :progress="_GetAdvance(layer.metadata, 'normalize')" :total-segments="5"></segmented-progress-bar>
      </div>
    </div>

    <b-tabs type="is-toggle" class="mt-5">
      <b-tab-item :label="$t('executed2')" icon="traffic-light" icon-pack="fas">
        <div class="flex items-center">
          <!-- <span class="text-gray-800 font-medium">Metodo de registro de avance</span> -->
        </div>

        <ul class="space-y-2 mt-1">
          <li class="flex item-center justify-between">
            <span class="uppercase text-gray-500 text-xs">{{ $t('advance_method') }}:</span>
            <span class="text-gray-800 text-sm">
              {{ config && config.advance_method ? config.advance_method.text : $t('undefined') }}
              <b-tooltip v-if="config && config.advance_method"
                :label="config.advance_method.description"
                multilined
                position="is-left"
              >
                <b-icon pack="fas" icon="question-circle" class="text-blue-lighter hover:text-blue cursor-help text-xs" />
              </b-tooltip>
            </span>
          </li>
          <li class="flex item-center justify-between">
            <span class="uppercase text-gray-500 text-xs">{{ $t('weighting_criteria') }}:</span>
            <span class="text-gray-800 text-sm">
              {{ config && config.weighting_criteria ? config.weighting_criteria.text : $t('undefined') }}
              <b-tooltip v-if="config && config.weighting_criteria"
                :label="config.weighting_criteria.description"
                multilined
                position="is-left"
              >
                <b-icon pack="fas" icon="question-circle" class="text-blue-lighter hover:text-blue cursor-help text-xs" />
              </b-tooltip>
            </span>
          </li>
        </ul>

        <div class="flex flex-col bg-gray-100 p-2 mt-5 rounded">
          <div class="item-center">
            <div>
              <h2 class="inline-block font-bold">{{ $t('progress_by_status') }}</h2>
            </div>
            <div class="flex items-center justify-end">

            </div>
          </div>
          <div class="flex mt-2 mb-2">
            <div class="w-full">
              <h3 class="inline-block font-semibold">{{ $t('status') }}</h3>
            </div>
            <div class="w-1/3 text-right">
              <h3 class="inline-block font-semibold text-right">{{ $t('weight') }}</h3>
            </div>
            <div class="w-1/3 text-right">
              <h3 class="inline-block font-semibold text-right">{{ $t('progress') }}</h3>
            </div>
          </div>
          <div v-if="_IsGroupedProgress(layer.metadata)">
            <ul class="space-y-2 mb-2">
              <template v-for="group in _GetStatusesLayer(layer.metadata, 'progress')">
                <li class="flex items-center gap-3">
                  <div class="relative truncate-x w-full h-6 bg-gray-100 rounded-sm">
                      <div
                        class="absolute inset-y-0 left-0 bg-green-light rounded-sm"
                        :style="{ width: group.advance + '%' }"></div>
                      <span class="relative z-10 block truncate text-sm font-medium text-gray-800 px-2 leading-6">
                        {{ $t('group') }}: {{ group.name }}
                      </span>
                  </div>
                  <div class="w-1/3 text-sm text-right text-gray-700">
                    <span>{{ group.weight }}</span>
                  </div>
                  <div class="w-1/3 text-sm text-right text-gray-700">
                    <span>{{ group.advance.toFixed(2) }}</span>
                  </div>
                </li>

                <li v-for="(status, key) in group.statuses" :key="'status_' + status.name"
                  class="flex items-center gap-1">
                  <div class="w-full flex gap-x-3">
                    <span class="flex ml-3 items-center uppercase text-gray-800 font-medium text-xs bg-white border-gray-200 border-1 rounded justify-center flex-shrink-0 w-6 h-6"
                      :style="{ backgroundColor: _GetColorStatus(status, layer) }">E</span>
                    <div class="flex items-center text-sm font-medium text-gray-600">{{ status.name }}</div>
                  </div>
                  <div class="w-1/3 text-sm text-gray-700 text-right">
                    <span>{{ status.weight ? status.weight : '-' }}</span>
                  </div>
                  <div class="w-1/3 text-sm text-gray-700 text-right">
                    <span>{{ status.advance.toFixed(2) }}</span>
                  </div>
                </li>
            </template>
            </ul>
          </div>
          <div v-else>
            <ul class="space-y-2">
              <li v-for="(status, key) in _GetStatusesLayer(layer.metadata, 'progress')" :key="'status_' + status.name"
                class="flex items-center gap-1">
                <div class="w-full flex gap-x-3">
                  <span class="flex ml-3 items-center uppercase text-gray-800-x text-white font-medium text-xs bg-white border-gray-200 border-1 rounded justify-center flex-shrink-0 w-6 h-6"
                    :style="{ backgroundColor: _GetColorStatus(key, layer) }">E</span>
                  <div class="flex items-center text-sm font-medium text-gray-600">{{ status.name }}</div>
                </div>
                <div class="w-1/3 text-sm text-gray-700 text-right">
                  <span>{{ status.weight ? status.weight : '-' }}</span>
                </div>
                <div class="w-1/3 text-sm text-gray-700 text-right">
                  <span>{{ status.advance }}</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </b-tab-item>
      <b-tab-item :label="$t('activity_status_issue')" icon="exclamation" icon-pack="fas">
        <div class="flex flex-col bg-gray-100 p-2 rounded">
          <div class="item-center">
            <div>
              <h2 class="inline-block font-bold">{{ $t('issues_by_status') }}</h2>
            </div>
            <div class="flex items-center justify-end">

            </div>
          </div>
          <div class="flex mt-2 mb-2">
            <div class="w-full">
              <h3 class="inline-block font-semibold">{{ $t('status') }}</h3>
            </div>
            <div class="w-1/3 text-right">
              <h3 class="inline-block font-semibold text-right">Total</h3>
            </div>
          </div>
          <div v-if="false">
            <ul class="space-y-2 mb-2">
              <template v-for="group in _GetStatusesLayer(layer.metadata)">
                <li class="flex items-center gap-3">
                  <div class="relative truncate-x w-full h-6 bg-gray-100 rounded-sm">
                      <div
                        class="absolute inset-y-0 left-0 bg-green-light rounded-sm"
                        :style="{ width: group.advance + '%' }"></div>
                      <span class="relative z-10 block truncate text-sm font-medium text-gray-800 px-2 leading-6">
                        {{ $t('group') }}: {{ group.name }}
                      </span>
                  </div>
                  <div class="w-1/3 text-sm text-right text-gray-700">
                    <span>{{ group.weight }}</span>
                  </div>
                  <div class="w-1/3 text-sm text-right text-gray-700">
                    <span>{{ group.advance }}</span>
                  </div>
                </li>

                <li v-for="(status, key) in group.statuses" :key="'status_' + status.name"
                  class="flex items-center gap-1">
                  <div class="w-full flex gap-x-3">
                    <span class="flex ml-3 items-center uppercase text-gray-800 font-medium text-xs bg-white border-gray-200 border-1 rounded justify-center flex-shrink-0 w-6 h-6"
                      :style="{ backgroundColor: _GetColorStatus(status, layer) }">E</span>
                    <div class="flex items-center text-sm font-medium text-gray-600">{{ status.name }}</div>
                  </div>
                  <div class="w-1/3 text-sm text-gray-700 text-right">
                    <span>{{ status.weight ? status.weight : '-' }}</span>
                  </div>
                  <div class="w-1/3 text-sm text-gray-700 text-right">
                    <span>{{ status.advance }}</span>
                  </div>
                </li>
            </template>
            </ul>
          </div>
          <div v-else>
            <ul class="space-y-2">
              <li v-for="(status, key) in _GetStatusesLayer(layer.metadata, 'incident')" :key="'incident_' + status.name"
                class="flex items-center gap-1">
                <div class="w-full flex gap-x-3">
                  <span class="flex ml-3 items-center uppercase text-gray-800-x text-white font-medium text-xs bg-white border-gray-200 border-1 rounded justify-center flex-shrink-0 w-6 h-6"
                    :style="{ backgroundColor: _GetColorStatus(key, layer, 'incident') }">E</span>
                  <div class="flex items-center text-sm font-medium text-gray-600">{{ status.name }}</div>
                </div>
                <div class="w-1/3 text-sm text-gray-700 text-right">
                  <span>{{ status.advance }}</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </b-tab-item>
    </b-tabs>

  </div>
</template>

<script>
import segmentedProgressBar from './segmented-progress-bar.vue';

import { getProgressLayerFromMetadata,
  getStatusesLayerFromMetadata,
  getConfigStatusesLayerFromMetadata,
  getMethodRegisterAdvanceSelected } from '../../services/helpers.service';

export default {
  name: 'ProgressSummaryLayer',

  components: {
    segmentedProgressBar,
  },

  props: {
    layer: {
      type: Object,
      required: true
    },
  },

  data() {
    return {
      isLoading: false,

      config: null,
    };
  },

  watch: {

  },

  mounted() {
    this._GetConfigStatusesLayer(this.layer.metadata);
  },

  methods: {
    _GetColorStatus(keyStatus, layer, type='progress') {
      const list = type === 'progress'
        ? (layer.statuses || [])
        : (layer.incident_statuses || []);

      const status = list.find(s => s.id == keyStatus);

      if (status && status.color) {
        return status.color;
      }

      return '#d1d5db'; // Default gray-300
    },

    _GetAdvance(metadata, type=null) {
      return getProgressLayerFromMetadata(metadata, type)
    },

    _GetStatusesLayer(metadata, type) {
      return getStatusesLayerFromMetadata(metadata, type);
    },

    _GetConfigStatusesLayer(metadata) {
      this.config = getMethodRegisterAdvanceSelected(metadata);
    },

    _IsGroupedProgress(metadata) {
      const cfg = getConfigStatusesLayerFromMetadata(metadata)
      return cfg && cfg.avance_method && cfg.avance_method === 'grouped';
    }
  }
}
</script>
